import {sendAmplitudeEvent} from '#/analytics/amplitude-events';
import {ModalContext} from '#/contexts/modal-provider';
import {WalletContext} from '#/contexts/wallet-provider';
import {useContext, useEffect, useRef} from 'react';

export const useSurveyModal = () => {
  const {
    accountResult: {isConnected, address},
    web3Auth,
  } = useContext(WalletContext);
  const {open} = useContext(ModalContext);
  const surveyShown = useRef(false);
  const isSurveyShown = localStorage.getItem('surveyShown') === 'true';

  useEffect(() => {
    if (!isConnected || !web3Auth?.connected || surveyShown.current || isSurveyShown) {
      return;
    }

    const timer = setTimeout(() => {
      open({
        name: 'SurveyModal',
        props: {},
      });
      sendAmplitudeEvent.surveyModalShown({
        event_properties: {
          wallet_address: address as string,
        },
      });
      localStorage.setItem('surveyShown', 'true');
      surveyShown.current = true;
    }, 1000 * 20); // 20 seconds

    return () => clearTimeout(timer);
  }, [isConnected, open, web3Auth?.connected, isSurveyShown, address]);
};
